export default __webpack_public_path__ + "static/media/mt.6aea2475.svg";